// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3Pr-Y","bigColWidth":"Table_bigColWidth__IE21j","biggerColWidth":"Table_biggerColWidth__35AJm","row":"Table_row__18CSH","col":"Table_col__1-59U"};